import update from 'immutability-helper';
import paymentApi from "../lib/api/payment";

// ------------------------------------
// Constants
// ------------------------------------
export const NEXT = 'CHECKOUT_PROCESS/NEXT';
export const POP = 'CHECKOUT_PROCESS/POP';
export const RESET = 'CHECKOUT_PROCESS/RESET';
export const START_LOADING = 'CHECKOUT_PROCESS/START_LOADING';
export const STOP_LOADING = 'CHECKOUT_PROCESS/STOP_LOADING';
export const CLEAR_STATE = 'CHECKOUT_PROCESS/CLEAR_STATE';
export const SCROLL_TO_TOP = 'CHECKOUT_PROCESS/SCROLL_TO_TOP';


// ------------------------------------
// Actions
// ------------------------------------

export function resetCheckoutIfNeeded() {
    return async (dispatch, getState) => {
        const checkoutHistory = getState().checkout.checkoutHistory
        if (checkoutHistory.length > 0) {
            const lastHistoryElement = checkoutHistory[checkoutHistory.length - 1];
            const method = lastHistoryElement.method;
            const provider = lastHistoryElement.provider;
            const payload = {
                history: checkoutHistory,
                method: method,
                provider: provider
            }
            const merchant = getState().merchant

            try {
                await paymentApi.reset(payload, merchant)
                dispatch(reset());

            } catch (e) {
                console.info('could not reset checkout', e.messageDe);
            }
        }
    };
}

export function next(payload) {
    return {
        type: NEXT,
        payload,
    };
}

export function pop(payload) {
    return {
        type: POP,
        payload,
    };
}
export function reset() {
    return {
        type: RESET,
    };
}

export function startLoading() {
    return {
        type: START_LOADING,
    };
}

export function stopLoading() {
    return {
        type: STOP_LOADING,
    };
}

export function scrollToTop() {
    return {
        type: SCROLL_TO_TOP,
    };
}

// ------------------------------------
// Action Creators
// ------------------------------------


// ------------------------------------
// Action Handlers
// ------------------------------------
const ACTION_HANDLERS = {
    [NEXT]: (state, action) => {
        return update(state,	{
            checkoutHistory: { $push: [action.payload] },
            isLoading: { $set: false },
        })
    },
    [POP]: (state, action) => {
        return update(state, {
            checkoutHistory: { $splice: [[state.checkoutHistory.length - action.payload, action.payload]] },
            isLoading: { $set: false },
        })
    },
    [RESET]: () => {
        return initialState
    },
    [CLEAR_STATE]: () => initialState,
    [START_LOADING]: (state) => update(state, {
        isLoading: { $set: true },
    }),
    [STOP_LOADING]: (state) => update(state, {
        isLoading: { $set: false },
    }),
    [SCROLL_TO_TOP]: (state) => {
        window.scrollTo(0, 0);
        return state
    },
};

// ------------------------------------
// Reducer
// ------------------------------------
export const initialState = {
    checkoutHistory: [],
    isLoading: false
};

export default function reducerFunction(state = initialState, action) {
    const handler = ACTION_HANDLERS[action.type];
    return handler ? handler(state, action) : state;
}
